import { getServerlessImageHandlerUrl } from '~/components/Image/helpers'

import { CurriculumCountryCodes } from '../constants/curriculum.const'
import { getCurriculumFlagSrcKey } from '../utils/curriculumFlag.utils'

// Masked, not filled: SVGImage loads the globe as an <img>, which CSS cannot recolour. One black path, so it tints whole.
const GLOBE_URL = getServerlessImageHandlerUrl({
  key: getCurriculumFlagSrcKey(CurriculumCountryCodes.DEFAULT),
  edits: undefined,
  isSvg: true,
})

const MASK = {
  maskImage: `url(${GLOBE_URL})`,
  WebkitMaskImage: `url(${GLOBE_URL})`,
  maskSize: 'contain',
  WebkitMaskSize: 'contain',
  maskRepeat: 'no-repeat',
  WebkitMaskRepeat: 'no-repeat',
  maskPosition: 'center',
  WebkitMaskPosition: 'center',
} as const

/** The pastel-blue globe shown while a US user has no state yet. */
export default function CurriculumUnsetFlag({ className }: { className?: string }): React.ReactElement {
  return <span aria-hidden className={`inline-block h-6 w-6 shrink-0 bg-blue-pastel ${className ?? ''}`} style={MASK} />
}
